import { COOKIES } from '@libs/core';

import type { Decisions } from '../types';
import { getDecisions } from '../utils/parseDecisions';
import { useCacheKey } from './useCacheKey';
import { useOptimizely } from './useOptimizely';

export function useDecisions(): Decisions;
export function useDecisions<F extends keyof Decisions>(flag: F): Decisions[F];
export function useDecisions<F extends keyof Decisions>(flag?: F) {
    const { context } = useOptimizely();
    const { cookies } = useCacheKey();

    const proxy = getDecisions({
        raw: cookies.get(COOKIES.X_PETM_DECISIONS),
        onFlagRead: flag => context?.decide(flag),
    });

    if (!flag) return proxy;
    return proxy[flag];
}
